import {useUser} from "../../user/hooks";
import {useIsEmailVerified} from "../../user/token";
import {CommentRestrictedVerifyEmail} from "./CommentRestrictedVerifyEmail";
import CommentTextareaWrapper from "./CommentTextareaWrapper";

const CreateComment = ({className}) => {
  const user = useUser();
  const isEmailVerified = useIsEmailVerified();

  if (!user) {
    return null;
  }

  if (!isEmailVerified) {
    return <CommentRestrictedVerifyEmail />;
  }

  return <CommentTextareaWrapper className={className} />;
};

export default CreateComment;
